import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=cc50876e"
import script from "./ListaClientes.vue?vue&type=script&lang=js"
export * from "./ListaClientes.vue?vue&type=script&lang=js"
import style0 from "./ListaClientes.vue?vue&type=style&index=0&id=cc50876e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports